"use client";

import { useEffect, useState } from "react";

export default function KdbMatchLeagues({ league, matches = [], render = () => null }) {
  const [isExpanded, setIsExpanded] = useState(true);
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const mql = window.matchMedia("(min-width: 1024px)");
    const apply = () => setIsDesktop(!!mql.matches);
    apply();
    if (mql.addEventListener) mql.addEventListener("change", apply);
    else mql.addListener(apply);
    return () => {
      if (mql.removeEventListener) mql.removeEventListener("change", apply);
      else mql.removeListener(apply);
    };
  }, []);

  if (!isDesktop) return <>{matches.map((match, idx) => render(match, idx))}</>;

  return (
    <>
      <tr className="h-[36px] kdb-table-league-bg text-[12px]">
        <td colSpan="100%">
          <div
            type="button"
            onClick={() => setIsExpanded((v) => !v)}
            className="flex w-full items-center gap-2 bg-transparent text-left"
          >
            {league?.logo ? (
              <img src={league.logo} className="h-3 w-4 rounded-sm border-0" alt="" />
            ) : null}
            <span className="font-bold text-[12px] text-gray-700">
              {league?.nameVN || league?.name || "Giải đấu"}
            </span>
            <svg
              className={`ml-auto h-4 w-4 text-gray-400 transition-transform ${
                isExpanded ? "" : "rotate-180"
              }`}
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
            </svg>
          </div>
        </td>
      </tr>
      {isExpanded ? matches.map((match, idx) => render(match, idx)) : null}
    </>
  );
}
